// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: wAaQ89pik4N-
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import LoginInput from "../../LoginInput"; // plasmic-import: IUjDjOBqC9S0/component
import ResetPasswordButton from "../../ResetPasswordButton"; // plasmic-import: m97W19GonCkW/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicResetPassword.module.css"; // plasmic-import: wAaQ89pik4N-/css
import vectors5RMwiMqTi from "./images/vectors.svg"; // plasmic-import: _5r-mwi_MQTi/picture

createPlasmicElementProxy;

export const PlasmicResetPassword__VariantProps = new Array();

export const PlasmicResetPassword__ArgProps = new Array();

const $$ = {};

function PlasmicResetPassword__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"dashboardLoginDarkTheme"}
            data-plasmic-override={overrides.dashboardLoginDarkTheme}
            className={classNames(projectcss.all, sty.dashboardLoginDarkTheme)}
          >
            <Stack__
              as={"div"}
              data-plasmic-name={"frame1"}
              data-plasmic-override={overrides.frame1}
              hasGap={true}
              className={classNames(projectcss.all, sty.frame1)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___8AqOq
                )}
              >
                {"Reset your password"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__bGPn3
                )}
              >
                {
                  "Enter the email associated with your Astrius account and we'll send you a link to reset your password"
                }
              </div>
              <div
                data-plasmic-name={"emailBox"}
                data-plasmic-override={overrides.emailBox}
                className={classNames(projectcss.all, sty.emailBox)}
              >
                <div
                  data-plasmic-name={"rectangle"}
                  data-plasmic-override={overrides.rectangle}
                  className={classNames(projectcss.all, sty.rectangle)}
                >
                  <LoginInput
                    data-plasmic-name={"loginEmailInput"}
                    data-plasmic-override={overrides.loginEmailInput}
                    className={classNames(
                      "__wab_instance",
                      sty.loginEmailInput
                    )}
                  />
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___7TiLo
                  )}
                >
                  {"Email"}
                </div>
              </div>
              <div
                data-plasmic-name={"invalidEmailText"}
                data-plasmic-override={overrides.invalidEmailText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.invalidEmailText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Invalid email address"}
                    </span>
                  </React.Fragment>
                ) : hasVariant(globalVariants, "screen", "medium") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Invalid email address"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Invalid email address"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"emailSuccessText"}
                data-plasmic-override={overrides.emailSuccessText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.emailSuccessText
                )}
              >
                {hasVariant(globalVariants, "screen", "small")
                  ? "Email has been sent"
                  : hasVariant(globalVariants, "screen", "medium")
                  ? "Email has been sent"
                  : "Email has been sent"}
              </div>
              <ResetPasswordButton
                data-plasmic-name={"resetPasswordButton"}
                data-plasmic-override={overrides.resetPasswordButton}
                className={classNames(
                  "__wab_instance",
                  sty.resetPasswordButton
                )}
              />
            </Stack__>
            <PlasmicImg__
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loading={"lazy"}
              src={{
                src: vectors5RMwiMqTi,
                fullWidth: 1280,
                fullHeight: 111,
                aspectRatio: 11.531532
              }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "dashboardLoginDarkTheme",
    "frame1",
    "emailBox",
    "rectangle",
    "loginEmailInput",
    "invalidEmailText",
    "emailSuccessText",
    "resetPasswordButton",
    "img"
  ],

  dashboardLoginDarkTheme: [
    "dashboardLoginDarkTheme",
    "frame1",
    "emailBox",
    "rectangle",
    "loginEmailInput",
    "invalidEmailText",
    "emailSuccessText",
    "resetPasswordButton",
    "img"
  ],

  frame1: [
    "frame1",
    "emailBox",
    "rectangle",
    "loginEmailInput",
    "invalidEmailText",
    "emailSuccessText",
    "resetPasswordButton"
  ],

  emailBox: ["emailBox", "rectangle", "loginEmailInput"],
  rectangle: ["rectangle", "loginEmailInput"],
  loginEmailInput: ["loginEmailInput"],
  invalidEmailText: ["invalidEmailText"],
  emailSuccessText: ["emailSuccessText"],
  resetPasswordButton: ["resetPasswordButton"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicResetPassword__ArgProps,
          internalVariantPropNames: PlasmicResetPassword__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicResetPassword__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicResetPassword";
  } else {
    func.displayName = `PlasmicResetPassword.${nodeName}`;
  }
  return func;
}

export const PlasmicResetPassword = Object.assign(
  // Top-level PlasmicResetPassword renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dashboardLoginDarkTheme: makeNodeComponent("dashboardLoginDarkTheme"),
    frame1: makeNodeComponent("frame1"),
    emailBox: makeNodeComponent("emailBox"),
    rectangle: makeNodeComponent("rectangle"),
    loginEmailInput: makeNodeComponent("loginEmailInput"),
    invalidEmailText: makeNodeComponent("invalidEmailText"),
    emailSuccessText: makeNodeComponent("emailSuccessText"),
    resetPasswordButton: makeNodeComponent("resetPasswordButton"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicResetPassword
    internalVariantProps: PlasmicResetPassword__VariantProps,
    internalArgProps: PlasmicResetPassword__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicResetPassword;
/* prettier-ignore-end */
